{
  "Every": "Every",
  "day(s)": "day(s)",
  "Every week day": "Every week day",
  "Start time": "Start time",
  "hour": "hour",
  "At": "At",
  "minute(s)": "minute(s)",
  "Day": "Day",
  "of every month(s)": "of every month(s)",
  "Last day of every month": "Last day of every month",
  "On the last weekday of every month": "On the last weekday of every month",
  "day(s) before the end of the month": "Day(s) before the end of the month",
  "Monday": "Monday",
  "Tuesday": "Tuesday",
  "Wednesday": "Wednesday",
  "Thursday": "Thursday",
  "Friday": "Friday",
  "Saturday": "Saturday",
  "Sunday": "Sunday",
  "Minutes": "Minutes",
  "Hourly": "Hourly",
  "Daily": "Daily",
  "Weekly": "Weekly",
  "Monthly": "Monthly",
  "Yearly": "Yearly",
  "Custom": "Custom",
  "Expression": "Expression",
  "Days of every month": "Days of every month",
  "Every year in": "Every year in",
  "on day": "on day",
  "January": "January",
  "February": "February",
  "March": "March",
  "April": "April",
  "May": "May",
  "June": "June",
  "July": "July",
  "August": "August",
  "September": "September",
  "October": "October",
  "November": "November",
  "December": "December"
}
